var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivateUtsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 67,
    viewBox: "0 0 152 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.332 22.0542H97.6874V57.1827H107.237V22.0542H116.584V13.6294H88.332V22.0542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3462 43.7257C70.3462 47.2324 68.279 49.4241 65.0458 49.4241C61.8125 49.4241 59.7011 47.2412 59.7011 43.7257V13.6294H50.1426V43.8572C50.1426 52.4749 56.1586 57.884 65.0369 57.884C73.9152 57.884 79.9312 52.51 79.9312 43.8572V13.6294H70.3462V43.7257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.313 31.3273L135.836 29.2758C132.832 28.1449 132.302 26.225 132.302 24.9626C132.302 22.578 134.069 20.7896 137.117 20.7896C140.164 20.7896 142.126 22.7797 142.126 25.8919V27.0841H151.075V26.0935C151.075 18.0018 145.465 12.9434 137.117 12.9434C128.362 12.9434 123.282 18.9048 123.282 25.5324C123.282 31.8971 126.631 35.6756 133 38.0601L139.184 40.3833C141.914 41.4441 142.983 42.8994 142.983 45.0911C142.983 48.1419 140.986 49.9303 137.373 49.9303C133.76 49.9303 131.569 48.2734 131.569 44.7579V43.1624H122.479V44.6878C122.479 52.7795 128.751 57.8379 137.302 57.8379C146.658 57.8379 152.002 52.2009 152.002 44.1793C152.002 36.1577 146.79 33.3699 141.313 31.3185",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13536 27.4275L-0.0117188 31.5444L4.1368 35.6599L8.28388 31.543L4.13536 27.4275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5889 32.537L20.7514 35.6667L24.8946 31.5551L20.672 27.3558C20.2671 26.9508 19.7854 26.6293 19.2547 26.4099C18.7241 26.1906 18.1549 26.0776 17.58 26.0776C17.0051 26.0776 16.436 26.1906 15.9053 26.4099C15.3746 26.6293 14.8929 26.9508 14.4881 27.3558L-0.0175781 41.7508L4.1256 45.8712L17.5889 32.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5736 50.0174L12.4215 45.897L9.25891 49.0355L6.10518 45.897L1.95312 50.0174L6.17581 54.2166C7.00149 55.0198 8.11158 55.4696 9.26776 55.4696C10.4239 55.4696 11.534 55.0198 12.3597 54.2166L16.5736 50.0174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.591 57.2723L14.4284 54.1426L10.2764 58.2629L14.5079 62.4535C14.9128 62.8585 15.3944 63.1799 15.9251 63.3993C16.4558 63.6187 17.025 63.7316 17.5998 63.7316C18.1747 63.7316 18.7439 63.6187 19.2746 63.3993C19.8053 63.1799 20.2869 62.8585 20.6918 62.4535L24.9234 58.2629L20.7713 54.1426L17.591 57.2723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8848 49.0355L22.7575 45.897L18.6055 50.0174L22.837 54.2166C23.6627 55.0198 24.7728 55.4696 25.929 55.4696C27.0852 55.4696 28.1953 55.0198 29.0209 54.2166L33.2436 50.0174L29.0916 45.897L25.8848 49.0355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0382 37.7102L26.8896 41.8257L31.043 45.9488L35.1915 41.8333L31.0382 37.7102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.591 40.7957L14.4284 37.666L10.2764 41.7776L14.5079 45.9768C14.9128 46.3818 15.3944 46.7033 15.9251 46.9227C16.4558 47.1421 17.025 47.255 17.5998 47.255C18.1747 47.255 18.7439 47.1421 19.2746 46.9227C19.8053 46.7033 20.2869 46.3818 20.6918 45.9768L35.1975 31.5818L31.0454 27.4614L17.591 40.7957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5941 -0.257039L12.0586 5.23438L17.5922 10.7277L23.1277 5.23626L17.5941 -0.257039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6831 17.731H14.6585V25.5247C15.5469 25.0042 16.5597 24.7296 17.5914 24.7296C18.6231 24.7296 19.6359 25.0042 20.5243 25.5247V17.731H24.5262L27.1323 20.3085L32.6624 14.8117L27.1323 9.32373L24.5262 11.9012H10.6831L8.08589 9.32373L2.54688 14.8117L8.08589 20.3085L10.6831 17.731Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateUtsLogo);
export default __webpack_public_path__ + "static/media/activate-uts-logo.3be8cb19.svg";
export { ForwardRef as ReactComponent };